<template>
  <!-- eslint-disable -->
  <div class="d-flex flex-column">
    <div class="d-flex flex-column">
      <div class="d-flex flex-column">
        <v-text-field class="panzoom-ignore" v-model="node.greaterThan" :label="'Greater than'" />
        <v-text-field class="panzoom-ignore" v-model="node.greaterThanOrEqual" :label="'Greater than or equal'" />
      </div>
      <div class="d-flex flex-column">
        <v-text-field class="panzoom-ignore" v-model="node.lessThan" :label="'Less than'" />
        <v-text-field class="panzoom-ignore" v-model="node.lessThanOrEqual" :label="'Less than or equal'" />
      </div>
    </div>

    <va-array-input
      class="ringba-tags-input"
      v-slot="props"
      v-model="node.ringbaTags"
      :label="'Ringba tags'"
      :add-button-text="'Add tag'"
      :block-label="'Ringba tag'"
      column-layout-without-drag
      allow-empty>
      <div class="d-flex mt-3">
        <v-text-field
          class="panzoom-ignore flex-1 mr-1"
          :label="'Tag'"
          :placeholder="'Tag'"
          persistent-placeholder
          v-model="node.ringbaTags[props.index].tag"
          @input="tagChange(props.index, $event)" />

        <v-select
          :disabled="!node.ringbaTags[props.index].tag"
          :label="'Value'"
          v-model="node.ringbaTags[props.index].value"
          class="panzoom-ignore flex-1 ml-1"
          hide-details
          :items="RINGBA_TAG_VALUES"
          attach
          :menu-props="{
            offsetOverflow: true,
            offsetY: true,
          }">
        </v-select>
      </div>
    </va-array-input>
  </div>
</template>

<script>
  import { RINGBA_TAG_VALUES } from "./constant";
  /* eslint-disable */
  export default {
    name: "MultiStepFormDecision",
    props: {
      node: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        RINGBA_TAG_VALUES,
      };
    },
    beforeMount() {
      if (!this.node?.ringbaTags?.length) {
        this.$set(this.node, "ringbaTags", []);
      }
    },
    methods: {
      tagChange(index, value) {
        if (!value) {
          this.node.ringbaTags[index].value = null;
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "@core/preset/preset/typography/index.scss";
  @import "@core/preset/preset/functions.scss";

  .ringba-tags-input {
    &::v-deep {
      .btn-custom-add {
        margin-top: 25px;
      }
      .column-layout-without-drag {
        & > div {
          &:not(:first-child) {
            border-top: 1px dashed get-color("primary-65");
            margin-top: 20px;
            padding-top: 20px;
          }
          &:last-of-type {
            border-bottom: 1px dashed get-color("primary-65");
            padding-bottom: 20px;
          }
        }
      }
    }
  }
</style>

